// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefitsDisability = {
  benefits_section_disability: {
    contentful_name: '[DEFAULT] Benefits Section - Disability',
    std_voluntary_label: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: '自愿:',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    std_voluntary_description: '您可以选择购买{coverage}。',
    std_employer_paid_label: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '由您的雇主支付:',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    std_employer_paid_description: '作为您薪酬的一部分,{employerName}为您提供{coverage}。',
    std_coverage_whole: '短期伤残保险,将支付您{salaryOrEP}的最高{percent}%,为期{weeks}周',
    std_coverage_split:
      '短期伤残保险,在前{weeksFirst}周支付最高{percentFirst}%的{salaryOrEP},在接下来的{weeksSecond}周支付最高{percentSecond}%的{salaryOrEP}',
    std_coverage_whole_with_weekly_max:
      '短期伤残保险,最多支付您{salaryOrEP}的{percent}%,期限为{weeks}周,每周最高{weeklyMax}',
    std_coverage_split_with_weekly_max:
      '短期伤残保险,将在前{weeksFirst}周支付您{salaryOrEP}的最高{percentFirst}%,在接下来的{weeksSecond}周支付最高{percentSecond}%,每周最高{weeklyMax}',
    std_additional_coverage_header: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: '附加保障(升级购买):',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    std_buy_up: '您可以将保障额度提高至您{salaryOrEP}的{maxPercent}%。',
    std_buy_up_with_weekly_max:
      '您可以将保障范围提高至您{salaryOrEP}的{maxPercent}%,需支付费用,每周合计最高可达{weeklyMax}。',
    std_coverage_begins_on: '保障从您受伤或患病的第 {dayInjury} 天开始生效。',
    std_coverage_begins_on_split: '保障从您受伤的第{dayInjury}天或患病的第{dayIllness}天开始生效。',
    std_eligible_pay: '符合条件的工资',
    std_salary: '薪资',
    ltd_core_benefit_description:
      '作为您薪酬的一部分,{employerName}为您提供长期伤残保险,该保险将支付您{salaryOrEP}的最高{percent}%。',
    ltd_voluntary_description: '您可以选择购买长期伤残保险,该保险将支付您{salaryOrEP}的最高{percent}%',
    ltd_core_monthly_max:
      '作为您薪酬的一部分,{employerName}为您提供长期伤残保险,该保险将支付您{salaryOrEP}的最高{percent}%,每月最高可达{max}。',
    ltd_voluntary_monthly_max:
      '您可以选择购买长期伤残保险,该保险将支付您{salaryOrEP}的最高{percent}%,每月最高可达{max}。',
    ltd_buy_up_description: '您可以支付费用将保障额度提高至您{salaryOrEP}的{percent}%。',
    ltd_buy_up_monthly_max: '您可以增加保障至您{salaryOrEP}的{percent}%,需支付费用,每月合并最高限额为{max}。',
    ltd_waiting_period_by_ssnra_age: '付款在{waitingPeriod}天后开始,并支付至社会保障正常退休年龄。',
    ltd_waiting_period_by_age: '等待期{waitingPeriod}天后开始支付,并支付至{age}岁。',
    ltd_waiting_period_by_years: '付款在{waitingPeriod}天后开始,支付期限为{years}年。',
    ltd_core_label: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '由您的雇主支付:',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    ltd_voluntary_label: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '自愿:',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    ltd_buy_up_label: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '附加保障(升级购买):',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
  },
};
